import React, { useEffect } from "react";
import { navigate } from "../../../routes";
import { price, round2 } from "../../../utils";
import { useAuth } from "../../Auth/useAuth";
import useTranslations from "../../Translations/useTranslations";
import { useCart } from "../useCart";
import "./CurrentCartItems.css";
import PackItems from "./PackItems";
import PlvItems from "./PlvItems";
import ProductItems from "./ProductItems";

function CurrentCartItems({
  disableControls = false,
  hidePriceDetails = false,
}) {
  const [{ user }, { isRoleOperator }] = useAuth();
  const [{ current_cart }, cartsMethods] = useCart(user.client_profile?.id);
  const trl = useTranslations();

  const cart_data = cartsMethods.getCartData();
  const max_mt_plv_offert = cartsMethods.getMaxMtPLVOffert(cart_data);
  const mt_plv_in_cart = Math.round(cart_data.cumul_plv_in_cart * 100) / 100;

  const getMtTotal = () => {
    if (!current_cart) return 0;
    const mt_total = cart_data.mt_total;
    // Remove packs remise
    const packs = current_cart.packs;

    const toDeduct = packs.reduce(
      (a, b) => (a += b.mt_remise * b.qte_commande),
      0,
    );

    const remisePlv = cart_data.remise_plv || 0;
    const remiseCommercial = parseFloat(current_cart.header?.MT_REMISE || 0);

    let plvFacturee = 0;
    if (mt_plv_in_cart > max_mt_plv_offert) {
      plvFacturee = mt_plv_in_cart - max_mt_plv_offert;
    }

    return round2(
      mt_total - remisePlv - remiseCommercial - toDeduct - plvFacturee,
    );
  };

  const getMtGrossTotal = () => {
    if (!current_cart) return 0;
    const mt_total = cart_data.mt_total;
    // Remove packs remise
    const packs = current_cart.packs;

    const toDeduct = packs.reduce(
      (a, b) => (a += b.mt_remise * b.qte_commande),
      0,
    );

    /* const remisePlv = cart_data.remise_plv || 0;

    let plvFacturee = 0;
    if (mt_plv_in_cart > max_mt_plv_offert) {
      plvFacturee = mt_plv_in_cart - max_mt_plv_offert;
    } */

    return round2(
      mt_total - toDeduct, // - plvFacturee,
    );
  };

  const renderRemisePlv = () => {
    const remisePlv = cart_data.remise_plv || 0;
    let plvFacturee = 0;
    if (mt_plv_in_cart > max_mt_plv_offert) {
      plvFacturee = mt_plv_in_cart - max_mt_plv_offert;
    }

    return (
      <React.Fragment>
        {mt_plv_in_cart > 0 && (
          <React.Fragment>
            <div>{renderExtraInfo("Remise PLV", remisePlv, true)}</div>
            {/*plvFacturee > 0 && (
              <div>{renderExtraInfo("PLV facturée", plvFacturee)}</div>
            )*/}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  const renderRemiseCommercial = () => {
    const footRemiseValue = parseFloat(current_cart.header?.MT_REMISE || 0);

    const renderEditableValue = (label, value) => (
      <div className="current-cart-price-item">
        <span className="current-cart-price-label">{label}</span>
        <span className="current-cart-price-value">
          <div className="rebate-input-wrapper">
            <div className="rebate-input-left">
              <i className="fa fa-pencil" aria-hidden="true"></i>
              <span className="rebate-input-sign">-</span>
            </div>
            <input
              className="cart-rebate-input"
              type="number"
              value={value}
              onChange={(e) => {
                e.preventDefault();
                e.stopPropagation();
                cartsMethods.changeFeetRemise({
                  creator: user.client_profile?.id,
                  remise: e.target.value,
                });
              }}
              onBlur={(e) => {
                const roundedValue = round2(parseFloat(e.target.value || 0));
                cartsMethods.changeFeetRemise({
                  creator: user.client_profile?.id,
                  remise: roundedValue,
                });
              }}
            />
            <span className="rebate-input-unit">€</span>
          </div>
        </span>
      </div>
    );

    return (
      <React.Fragment>
        {isRoleOperator() ? (
          renderEditableValue("Remise commerciale", footRemiseValue)
        ) : (
          footRemiseValue > 0 && (
            <div>{renderExtraInfo("Remise commerciale", footRemiseValue, true)}</div>
          )
        )}
      </React.Fragment>
    );
  };

  const getFraisPort = () => {
    if (!current_cart) return 0;
    const { client } = current_cart;
    const mt_port_base = client.has_commande
      ? client.groupe_tarifaire.MT_PORT2
      : client.groupe_tarifaire.MT_PORT1;
    const franco_port = client.groupe_tarifaire.MT_FRANCO2;

    const total_HT = getMtTotal();

    const frais_port = total_HT >= franco_port ? 0 : mt_port_base;

    return frais_port;
  };

  const thresHoldMinValue = () => {
    if (!current_cart) return 0;
    const { MT_MINI_COMMANDE } = current_cart.client.groupe_tarifaire;
    return MT_MINI_COMMANDE;
  };

  const grossTotalDiscountExcl = () => {
    const grossTotal = getMtGrossTotal() || 0;
    return round2(grossTotal);
  };

  function renderExtraInfo(label, value, isDiscount = false) {
    let formattedValue = value;

    if (value <= 0) {
      formattedValue = "offerts !";
    } else {
      formattedValue = (isDiscount ? "- " : "") + price(value) + " €";
    }
    return (
      <React.Fragment>
        <div className="current-cart-price-item">
          <span className="current-cart-price-label">{label}</span>
          <span className="current-cart-price-value">{formattedValue}</span>
        </div>
      </React.Fragment>
    );
  }

  const totalAmount = round2(getMtTotal());
  const fraisPort = round2(getFraisPort());
  useEffect(() => {
    if (disableControls && totalAmount === 0) {
      navigate.goBack();
    }
  }, [disableControls, totalAmount]);

  return (
    <React.Fragment>
      <div className="current-cart-items">
        <PackItems disableControls={disableControls} />
        <ProductItems disableControls={disableControls} />
        <PlvItems disableControls={disableControls} />
      </div>
      {!hidePriceDetails && (
        <React.Fragment>
          <div className="spacer" />
          <div className="current-cart-price-section">
            {renderExtraInfo("Total", grossTotalDiscountExcl())}
            {renderExtraInfo("Frais de livraison", fraisPort)}
            {/*renderExtraInfo("Total", totalAmount)*/}
            {renderRemisePlv()}
            {renderRemiseCommercial()}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default CurrentCartItems;
